import { Button, Popconfirm, Tooltip } from "antd";
import React, { FC, Fragment, useEffect, useState } from "react";

import "katex/dist/katex.min.css";
import Latex from "react-latex-next";

//IMAGES
import EnglishIcon from "assets/images/students/englishIcon.svg";
import FrenchIcon from "assets/images/students/frenchIcon.svg";
import StartIcon from "assets/images/students/teacherStart.svg";
import TEACHER from "../../../../assets/images/teacher/teacher.svg";

import InstaIcon from "../../../../assets/images/app/insta_icon.svg";
import LikeIcon from "../../../../assets/images/app/like_icon.svg";
import MessageIcon from "../../../../assets/images/app/message_icon.svg";
import PlanningButtonIcon from "../../../../assets/images/app/planning_icon.svg";


//!STYLES
import { FLAGS, removeDuplicates } from "common/enums";
import { useDispatch, useSelector } from "react-redux";
import { setIsDrawerInstaProf } from "store/chat/roomSlice";
import s from "./assets/cardTeacher.module.css";

import * as appRoutes from "config/routes.config";

import { useNavigate } from "react-router-dom";
import { setIdTeacher, setSeeAvis, setStudentAcceptedInstaProf } from "store/auth/authSlice";
import { openPaiementDrawer } from "store/chat/mainSlice";
import { handleClearTopicStrings, handleClearTopicStringsLength } from "utils/formats";

import CertificationBadge from "components/certificationBadge";
import {
  setChatReceiverId,
  setSelectUserChat,
  toggleAppChat
} from "store/AppChat/appChat";
import { useFindRoomMutation } from "store/services/chat";
import IconCourse from "./iconCourse";

interface CardAdsTeacher {
  ad: any;
  PlanningIsVisble?: boolean;
  isInstaProf?: boolean;
  instaProfData?: any;
  infoTeacherAcceptedReservation?: any;
  currentProfAccepted?: any;
  setCurrentProfAccepted?: any;
  isBtnInstaProf: boolean;
  resetDrawerInstaProf?: () => void;
  handleStudentAcceptTeacher?: any;
  showDrawerSearchInstaProf: () => void;
  handleDisplayTeacher: (id: string) => void;
  onShowDrawerCalendarProf: () => void;
  handleOpenDrwerProfileTeacher: () => void;
  setIsBtnInstaProf: React.Dispatch<React.SetStateAction<boolean>>;
  suggestedTeachers?: boolean;
}

const CardAdsTeacher: FC<CardAdsTeacher> = ({
  ad,
  PlanningIsVisble = true,
  isInstaProf,
  isBtnInstaProf,
  handleStudentAcceptTeacher,
  setCurrentProfAccepted,
  onShowDrawerCalendarProf,
  setIsBtnInstaProf,
  handleDisplayTeacher,
  handleOpenDrwerProfileTeacher,
  showDrawerSearchInstaProf,
  suggestedTeachers,
}) => {
  //!HOOKS
  const { user, isLoggedIn } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [findRoom, { isSuccess }] = useFindRoomMutation();

  const closeDrawerPaiement = () => {
    dispatch(openPaiementDrawer());
  };

  const day = new Date();

  const handleDisplayTeacherMSG = (idTeacher: string) => {
    if (isInstaProf) {
      dispatch(setIsDrawerInstaProf(true));
    }
    const finalData = {
      actor1: user?._id,
      actor2: idTeacher,
      flag: FLAGS.SINGLE_FLAG,
      type: `${isInstaProf ? "instaprof" : ""}`,
      instaprof: `${isInstaProf ? "find" : ""}`,
    };

    findRoom(finalData);
    dispatch(setChatReceiverId(idTeacher));
  };

  const handleProfileClick = () => {
    if (isLoggedIn) {
      dispatch(setIdTeacher(ad?._id));
      isInstaProf && handleOpenDrwerProfileTeacher();
      const profileUrl = `${appRoutes.PROFILETEACHER}/${ad?.teacher?._id}/${ad?.teacher?.firstname ? ad?.teacher?.firstname : "nom"}.${ad?.teacher?.lastname ? ad?.teacher?.lastname : "complet"}`;
      window.open(profileUrl, "_blank");
    } else {
      dispatch(setIdTeacher(ad?._id));
      const profileUrl = `${appRoutes.PROFILETEACHER}/${ad?.teacher?._id}/${ad?.teacher?.firstname ? ad?.teacher?.firstname : "nom"}.${ad?.teacher?.lastname ? ad?.teacher?.lastname : "complet"}`;
      window.open(profileUrl, "_blank");
    }
  }

  const getLevelPrice = (data: any) => {
    const level = localStorage.getItem("level");
    const levelData = data.find((item: any) => item?.niveau._id === level);
    return levelData?.matieres.length ? levelData.matieres[0].cost : 0;
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(setSelectUserChat(true));
      dispatch(toggleAppChat(true));
    }
  }, [isSuccess, ad]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };
  window.addEventListener('resize', handleResize);

  return (
    <React.Fragment>
      <div className={`${isInstaProf ? s.teacherCard : s.card} ${!isInstaProf && `square`}`} >
        {suggestedTeachers && user?.accountManaged !== "" && ad?.credits !== 0 && <div className={s.ribbon}>
          <img src={LikeIcon} height={isMobile ? 10 : 12} style={{ position: "relative", bottom: isMobile ? "0px" : "2px", marginRight: "5px" }}></img> Recommandé
          {ad?.credits > 0 && <div> : {Number(ad?.credits).toFixed(2)} <span className={s.credit}>CDT</span></div>}
        </div>}
        <div className={isInstaProf ? s.avatarNameBoxInsta : s.avatarNameBox} onClick={handleProfileClick}>
          <div className={s.avatarBox}><img src={ad?.teacher?.profile || TEACHER} height={isMobile ? 40 : 70} style={{ borderRadius: "50%" }} /></div>
          <div className={s.nameRateBox}>
            <Tooltip
              title={
                <span style={{ textTransform: "capitalize" }}>
                  {ad?.teacher?.firstname + " " + ad?.teacher?.lastname ||
                    "-"}
                </span>
              }
            >
              <div className={s.nameBox}>
                {ad?.teacher?.firstname?.split(" ")[0] || "-"}{" "}
                {ad?.teacher?.lastname?.split(" ")[0] || "-"}
                {ad?.teacher?.certified && <CertificationBadge />}
              </div>
            </Tooltip>

            <span style={{ textTransform: "uppercase", lineHeight: isMobile ? "10px" : "14px" }}>
              {ad?.teacher?.points > 0 &&
                ad?.teacher?.points <= 1000 &&
                "C'est mon ami"}
              {ad?.teacher?.points > 1000 &&
                ad?.teacher?.points <= 5000 &&
                "C'est mon grand ami"}
              {ad?.teacher?.points > 5000 &&
                ad?.teacher?.points <= 10000 &&
                "C'est mon vieil ami"}
              {ad?.teacher?.points > 10000 && "Tu es mon meilleur ami"}
            </span>

            <div className={s.rate} style={{ lineHeight: isMobile ? "15px" : "20px" }} onClick={() => {
              dispatch(setSeeAvis(user ? true : false));
              handleProfileClick();
            }}>
              <span className={s.rateNumber}>
                {ad?.teacher?.rate && ad?.teacher?.rate !== 0 && Number(ad?.teacher?.rate).toFixed(2)}
                {ad?.teacher?.rate && ad?.teacher?.rate !== 0 && <img src={StartIcon} style={{ position: "relative", top: "-2px", marginLeft: "5px", marginRight: "5px" }} />}
                {ad?.teacher?.rateNum && ad?.teacher?.rateNum !== 0 && `(${ad?.teacher?.rateNum || 0} avis)`}
              </span>
            </div>

            <div style={{ color: "#707070", lineHeight: "10px" }}>
              {!isInstaProf && (
                <>
                  <span>
                    Je parle
                  </span>{" "}
                  {ad?.language?.includes("en") && (
                    <>
                      <img src={EnglishIcon} alt="" />{" "}
                    </>
                  )}
                  {ad?.language?.includes("fr") && (
                    <img src={FrenchIcon} alt="" />
                  )}
                </>
              )}

              {isInstaProf && (
                <Fragment>
                  <span>
                    Je parle
                  </span>{" "}
                  {ad?.teacher?.langues?.includes("en") && (
                    <>
                      <img src={EnglishIcon} alt="" />{" "}
                    </>
                  )}
                  {ad?.teacher?.langues?.includes("fr") && (
                    <img src={FrenchIcon} alt="" />
                  )}
                </Fragment>
              )}
            </div>
          </div>
        </div>
        <div className={isInstaProf ? s.__descriptionInsta : s.__description}>
          <Latex>
            {ad?.teacher?.career
              ? isInstaProf ? ad?.teacher?.career?.replace(/<\/?strong>/g, '').split("</p>")[0].substring(0, 70)?.concat(ad?.teacher?.career?.replace(/<\/?strong>/g, '').split("</p>")[0].length < 70 ? "" : "...") : ad?.teacher?.career?.replace(/<\/?strong>/g, '').split("</p>")[0].substring(0, 70)?.concat(ad?.teacher?.career?.replace(/<\/?strong>/g, '').split("</p>")[0].length < 70 ? "" : "...")
              : "Aucune description disponible"}
          </Latex>
        </div>
        <div className={isInstaProf ? s.matiersInsta : s.matiers}>
          {handleClearTopicStrings(ad?.teacher?.matieres)?.slice(0, isMobile ? 3 : 6).map((item: string) =>
            item ? (
              <div className={s.course} key={item}>
                <IconCourse course={item} />
                <span>
                  {item.includes("-")
                    ? item.split("-")[0]
                    : item === "Anglais"
                      ? "Anglais"
                      : item === "Mathématiques"
                        ? "Maths"
                        : item}
                </span>
              </div>
            ) : null
          )} {isMobile && handleClearTopicStringsLength(ad?.teacher?.matieres) > 3 && "..."}
        </div>
        <div className={isInstaProf ? s.levelGroupInsta : s.levelGroup}>
          {ad?.teacher?.groupLevels?.length > 0 ? <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "5px" }}>
            {removeDuplicates(ad?.teacher?.groupLevels)?.slice(0, isMobile ? 3 : 6).map((level: any, index: number) => {
              return (
                level?.price !== "" && <div key={index} style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
                  <div className="teacherLevelBox" key={index}>{level?.levelGroup}</div>
                </div>
              );
            })} {isMobile && ad?.teacher?.groupLevels?.length > 3 && "..."}
          </div> : <span>Non renseigné</span>}
        </div>
        {!suggestedTeachers && <div className={isInstaProf ? s.tarifInsta : s.tarif}>
          <span>Mes cours à partir de</span>{" "}
          {getLevelPrice(ad?.teacher?.nivMat)}€/séance
        </div>}
        <div className={isInstaProf ? s.rowButtonsInsta : s.rowButtons}>
          {PlanningIsVisble && (
            <Button className={s.newPlanningButton} onClick={onShowDrawerCalendarProf}>
              <img
                src={PlanningButtonIcon}
                alt=""
                style={{
                  position: "relative",
                  top: "-1px",
                  marginRight: "5px",
                }}
              />
              Mon Planning
            </Button>
          )}

          {isInstaProf && (
            <Popconfirm
              placement="top"
              title={"Veux-tu accepter ce prof ?"}
              onConfirm={() => { dispatch(setStudentAcceptedInstaProf(true)); handleStudentAcceptTeacher(ad); }}
              okText="Oui"
              cancelText="Non"
            >
              <Button className={s.newPlanningButton} onClick={() => setCurrentProfAccepted(ad)}>
                Accepter
              </Button>
            </Popconfirm>
          )}

          {!isInstaProf && ad?.teacher?.instaProf && (
            <Button
              onClick={() => {
                setIsBtnInstaProf(true);
                showDrawerSearchInstaProf();
              }}
              className={s.newInstaButton}
            >
              <img
                src={InstaIcon}
                alt=""
                style={{ height: isMobile ? "15px" : "20px", marginRight: "5px" }}
              />
              InstaProf
            </Button>
          )}

          {!isInstaProf && user?._id && (
            <Button
              onClick={() => {
                isInstaProf
                  ? handleDisplayTeacher(ad?.teacher?._id)
                  : handleDisplayTeacherMSG(ad?.teacher?._id);
              }}
              className={s.newMessageButton}
            >
              <img src={MessageIcon} height={isMobile ? 12 : 14} />
            </Button>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default CardAdsTeacher;
